import React from 'react';
import { Button as AntButton } from 'antd';
import classNames from 'classnames';
import './Button.scss';

const Button = ({
  onClick,
  secondary = false,
  children,
  className,
  iconUrl,
  loading,
  shouldBtnDisable,
  icon,
  ...rest
}) => {
  const buttonClasses = classNames(
    'button h-auto p-4 my-2 border-blue-light rounded-none font-medium text-md uppercase',
    {
      'shadow-lg': !secondary,
      'flex justify-center items-center': loading,
      'bg-white text-blue-light hover:bg-white hover:text-blue-light focus:bg-white focus:text-blue-light': secondary,
      'bg-blue-dark text-white hover:bg-blue-light hover:text-white focus:bg-blue-light focus:text-white': !secondary,
    },
    className
  );
  const contentClasses = classNames('tracking-widest', {
    'ml-4': iconUrl || icon || loading,
    'flex justify-center items-center': !loading,
  });
  return (
    <AntButton
      disabled={shouldBtnDisable}
      loading={loading}
      className={buttonClasses}
      onClick={onClick}
      icon={icon}
      {...rest}
    >
      <div className={contentClasses}>
        {iconUrl && !loading && (
          <img className="mr-4 h-6" src={iconUrl} alt="Button Icon" />
        )}
        {children}
      </div>
    </AntButton>
  );
};

export default Button;
